module.exports = __webpack_public_path__ + "static/media/8OLA2.58c96323.jpg";